import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

export const lang = {
  DeleteConversationConfirm: '确认删除该对话？',
  home: '首页',
  coolguaCloudMatchShowSystem: '预约配对系统',
  exhibitorLogin: '参展商登录',
  buyerLogin: '专业观众登录',
  MemorizePassword: '记住密码',
  AutomaticLogon: '自动登录',
  Login: '登录',
  MobilePhoneNumberOrEmail: '请输入手机号/邮箱',
  Password: '请输入密码',
  validate: '请输入验证码',
  buyerInformation: '浏览采购商',
  ExhibitorInformation: '浏览参展商',
  appointmentSchedule: '预约日程',
  pleaseChangePassword: '请修改您的密码',
  oldPassword: '旧密码',
  newPassword: '新密码',
  comfirmPassword: '确认密码',
  EditConfirmation: '编辑确认',
  AreYouSureYouWantToChangeYourPassword: '您确定要修改密码吗？',
  PasswordSuccessfullyModified: '密码修改成功！',
  Query: '查询失败，请重试！',
  search: '搜索',
  reset: "重置",
  save: '保存',
  cancel: '取消',
  myProfile: "我的资料",
  changePassword: '修改密码',
  logOff: "注销",
  submit: '确定',
  return: '返回',
  cancelled: '已取消',
  CompleteYourProfile: "请完善您的资料",
  country: '国家',
  province: '省份',
  city: '城市',
  choose: '请选择',
  Submission: '提交',
  ProductType: '产品类型',
  getFail: '获取失败！',
  notEmpty: '不能为空！',
  EnterTheCorrectMobilePhoneNumber: '请输入正确的手机号！',
  Mobilerepeated: '手机号重复,请重新输入！',
  EnterTheCorrectEmail: '请输入正确的邮箱号！',
  Mailboxrepeated: '邮箱重复,请重新输入！',
  SuccessfullyChanged: '修改成功!',
  UnableToChangePleaseTryAgain: '修改失败，请重试!',
  selectPicture: '选择图片',
  uploadPicture: '上传图片',
  uploadSuccess: '上传成功',
  uploadFail: '上传失败',
  mustPicture: '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种',
  MakeAppointments: '发出预约',
  close: '关闭',
  Monday: '星期一',
  Tuesday: '星期二',
  Wednesday: '星期三',
  Thursday: '星期四',
  Friday: '星期五',
  Saturday: '星期六',
  Sunday: '星期日',
  displayAll: '显示全部',
  displaySuccessfulAppointments: '只显示成功的预约',
  displayPendingAppointments: '只显示待定的预约',
  Exhibitors: '参展商',
  Buyers: '采购商',
  AppointmentInformation: '预约信息',
  AppointmentTime: '预约时间',
  Initiator: '发起方',
  LeaveMessage: '留言',
  PleaseChooseTheAppointmentTime: '请选择预约时间',
  Time: '时间',
  AM: '上午',
  PM: '下午',
  messageContent: '请输入留言内容',
  successfulAppointment: '预约成功',
  Total: '合计',
  appointmentsList: '预约日程表',
  Download: '下载',
  To: '至',
  BoothNO: '展位号',
  Identity: '身份',
  SuccessfullyAcceptTheAppointment: '您已成功接受对方预约申请',
  YourRescheduleApplicationHasBeenSentToTheTargetObjectPleaseBePatientAndWaitForFeedback: '您的改期申请已发送给对方，请耐心等待对方反馈',
  ChangeTime: '改期',
  WaitingForDetermination: '等待对方处理',
  Accept: '接受',
  AgreeToReschedule: '接受改期',
  SuccessfullyReschedule: '改期成功',
  UnableToSearchPleaseTryAgain: '查询失败，请重试',
  More: '更多/隐藏',
  All: '全选',
  seeMore: '更多',
  OrderNumber: '序号',
  name: '姓名',
  job: '职位',
  Company: '公司',
  Operator: '操作',
  Check: '查看',
  SuccessfullyMakeAnAppointment: '预约成功!',
  userEmpty: '用户名不能为空!',
  passwordEmpty: '密码不能为空!',
  codeEmpty: '验证码不能为空!',
  /*=== begin yiwu */
  "matchToDemands": "匹配需求",//匹配需求
  "demandForDetails": "需求详情",//需求详情
  "productPicture": "产品图片",//产品图片
  "matchToExhibits": "匹配展品",//匹配展品
  "introductionToProducts": "产品介绍",//产品介绍
  "MatchToBuyers": "匹配采购商",//匹配采购商
  "MatchToDemands": "匹配需求",//匹配需求
  "viewMore": "查看更多",//查看更多
  "myInformation": "我的资料",//我的资料
  "展商服务": "展商服务",
  "配套活动": "配套活动",
  "我的直播": "我的直播",
  "我的预约": "我的预约",
  "我的消息": "我的消息",
  "我的资料": "我的资料",
  "我的需求": "我的需求",
  "匹配展商": "匹配展商",
  "客服电话": "客服电话",
  "退出登录": "退出登录",
  "查看更多": "查看更多",
  "推荐展商": "推荐展商",
  "推荐展品": "推荐展品",
  "咨询": "咨询",
  "预约": "预约",
  "公司": "公司",
  "产品类型": "产品类型",
  "主营的产品类型": "主营的产品类型",
  "原密码": "原密码",
  "新密码": "新密码",
  "确认密码": "确认密码",
  "展馆号": "展馆号",
  "展位号": "展位号",
  "产品类型": "主营产品类型",
  "请先同意承诺书": "请先同意承诺书",
  "我已阅读并且同意": "我已阅读并且同意",
  "暂无": "暂无",
  "公司英文": "公司英文",
  "网址": "网址",
  "编辑资料": "编辑资料",
  "目前没有数据": "目前没有数据",
  "目前没人在直播": "目前没人在直播",
  "宣传视频": "宣传视频",
  "公司介绍": "公司介绍",
  "展品": "展品",
  "展商详情": "展商详情",
  "搜索": "搜索",
  "查看详情": "查看详情",
  "查看": "查看",
  "首页": "首页",
  "视频直播": "展商直播",
  "业务性质": "业务性质",
  "感兴趣的产品类型": "感兴趣的产品类型",
  "感兴趣产品": "感兴趣产品",
  "主营产品类型": "主营产品类型",
  "请先填写标题": "请先填写标题",
  "不能为空": "不能为空",
  "数量": "数量",
  "价格幅度": "价格幅度",
  "材质规格": "材质规格",
  "需求产品类型": "需求产品类型",
  "查看采购商": "查看采购商",
  "采购商详情": "采购商详情",
  "匹配采购商": "匹配采购商",
  "发布的需求": "发布的需求",
  "序号": "序号",
  "采购商品类型": "采购商品类型",
  "采购商品名称": "采购商品名称",
  "操作": "操作",
  "视频通话": "视频通话",
  "发送邀请": "发送邀请",
  "修改密码": "修改密码",
  "目前没有匹配数据": "目前没有匹配数据",
  "友情链接": "友情链接",
  "展会介绍": "展会概况",
  "参展商": "参展商",
  "采购商": "采购商",
  "场馆指南": "场馆指南",
  "交通指南": "交通指南",
  "发布需求": "发布需求",
  "匹配展品": "匹配展品",
  "人": "人",
  "预约视频会议": "预约视频会议",
  "发送消息": "发送消息",
  "审核通过": "审核通过",
  "编辑": "编辑",
  "采购商/采购企业名称": "采购商/采购企业名称",
  "产品名称不能为空": "产品名称不能为空",
  "请选择产品类别": "选择产品类别",
  "国家": "国家",
  "采购商品品类": "采购商品品类",
  "需求名称": "需求名称",
  "产品名称": "需求名称",
  "名称": "名称",
  "采购商品数量": "采购商品数量",
  "材质/规格": "材质/规格",
  "图片1": "图片1",
  "图片2": "图片2",
  "图片3": "图片3",
  "图片4": "图片4",
  "取消": "取消",
  "取消成功": "取消成功",
  "点击上传": "点击上传",
  "保存修改": "保存修改",
  "返回": "返回",
  "活动": "活动 ",
  "会议房间 数量": "会议房间 数量",
  "洽谈时长 （分钟）": "洽谈时长 （分钟）",
  "会议已结束": "会议已结束",
  "商贸配对活动": "商贸配对活动",
  "活动列表": "活动列表",
  "活动时间": "活动时间",
  "活动规则": "活动规则",
  "产品类别": "产品类别",
  "修改成功": "修改成功",
  "邀约成功": "邀约成功",
  "预计时间": "预计时间",
  "暂无数据": "暂无数据",
  "暂无活动": "暂无活动",
  "进入会议": "进入会议",
  "进入": "进入",
  "审核状态": "审核状态",
  "请完善您的资料": "请完善您的资料",
  "请填写主题": "请填写主题",
  "您还没有完善个人信息，请填写完毕后在操作": "您还没有完善个人信息，请填写完毕后在操作",
  "活动已结束": "活动已结束",
  "状态": "状态",
  "进行中": "进行中",
  "未开始": "未开始",
  "已结束": "已结束",
  "国籍": "国籍",
  "预约主题": "预约主题",
  "日期": "日期",
  "会议时间": "会议时间",
  "开始时间": "开始时间",
  "结束时间": "结束时间",
  "留言": "留言",
  "确认": "确认",
  "我的产品": "我的产品",
  "我的点赞": "我的点赞",
  "点赞": "点赞",
  "收藏": "收藏",
  "我的收藏": "我的收藏",
  "点赞我的": "点赞我的",
  "收藏我的": "收藏我的",
  "新增产品": "新增产品",
  "产品中文名称": "产品中文名称",
  "产品英文名称": "产品英文名称",
  "产品图片": "产品图片",
  "设为封面": "设为封面",
  "产品中文简介": "产品中文简介",
  "产品英文简介": "产品英文简介",
  "保存": "保存",
  "参展商登录": "参展商登录",
  "会议结束时间": "会议结束时间",
  "专业观众登录": "专业观众登录",
  "请输入验证码": "请输入验证码",
  "请输入正确的邮箱!": "请输入正确的邮箱!",
  "请输入价格幅度": "请输入价格幅度",
  "确定": "确定",
  "获取验证码": "获取验证码",
  "记住密码": "记住密码",
  "自动登录": "自动登录",
  "请输入账号": "请输入账号",
  "手机号码或邮箱": "手机号码或邮箱",
  "请输入手机号码或邮箱": "请输入手机号码或邮箱",
  "请输入密码": "请输入密码",
  "获取邮箱验证码": "获取邮箱验证码",
  "后可重新发送": "后可重新发送",
  "请输入手机号": "请输入手机号",
  "手机号": "手机号",
  "手机": "手机",
  "邮箱": "邮箱",
  "请输入邮箱": "请输入邮箱",
  "账号": "账号",
  "请输入手机验证码": "请输入手机验证码",
  "验证码": "验证码",
  "请输入邮箱验证码": "请输入邮箱验证码",
  "删除": "删除",
  "到": "到",
  "发起预约": "发起预约",
  "取 消": "取 消",
  "确 认": "确 认",
  "预约成功": "预约成功",
  "倒计时": "倒计时",
  "图片1不能为空": "图片1不能为空",
  "请输入": "请输入",
  "请输入关键字": "请输入关键字",
  "上传": "上传",
  "会议开启倒计时": "会议开启倒计时",
  "活动名称": "活动名称",
  "确 定": "确 定",
  "公司图片": "公司图片",
  "公司简介": "公司简介",
  "立即预约": "立即预约",
  "查看预约": "查看预约",
  "洽谈时长(分钟)": "洽谈时长(分钟)",
  "热门展商": "热门展商",
  "采购需求": "采购需求",
  "展商名称": "展商名称",
  "没有获取到对应的数据": "没有获取到对应的数据",
  "登录成功": "登录成功",
  "注册": "注册",
  "如您未注册请您先": "如您未注册请您先",
  "确定要切换语言吗？": "确定要切换语言吗？",
  "选择日期": "选择日期",
  "采购商品类": "采购商品类",
  "会议房间数量": "会议房间数量",
  "在线人数": "在线人数",
  "目前还没有人留言,留下你的精彩评论吧": "目前还没有人留言,留下你的精彩评论吧",
  "发送": "发送",
  "提交": "提交",
  "已拒绝": "已拒绝",
  "已取消": "已取消",
  "待确认": "待确认",
  "已确认": "已确认",
  "我收到的预约": "我收到的预约",
  "被拒绝": "被拒绝",
  "我发起的预约": "我发起的预约",
  "公司": "公司",
  "邀约时间": "邀约时间",
  "发起时间": "发起时间",
  "被发起时间": "发起时间",
  "我的日程": "我的日程",
  "上个月": "上个月",
  "下个月": "下个月",
  "联系人": "联系人",
  "取消预约": "取消预约",
  "提醒对方": "提醒对方",
  "已过期": "已过期",
  "之后可以操作": "之后可以操作",
  "再次发起预约": "再次发起预约",
  "会议开始时间": "会议开始时间",
  "确定要注销吗": "确定要注销吗",
  "注销成功，界面即将刷新": "注销成功，界面即将刷新",
  "结束会议": "结束会议",
  "退出视频": "退出视频",
  "视频结束": "视频结束",
  "退出会议": "退出会议",
  "拒绝": "拒绝",
  "请输入邮箱": "请输入邮箱",
  "请输入邮箱!": "请输入邮箱!",
  "更多说明": "更多说明",
  "发起直播": "发起直播",
  "服务器和串流密钥只生成一次,请妥善保管": "服务器和串流密钥只生成一次,请妥善保管",
  "发起直播方法": "发起直播方法",
  "小程序:请打开扫码开始直播": "小程序:请打开扫码开始直播",
  "PC端": "PC",
  "OBS推流": "OBS推流",
  "开启直播": "开启直播",
  "点击查看操作手册": "点击查看操作手册",
  "服务器": "服务器",
  "串流密钥": "串流密钥",
  "查看直播": "查看直播",
  "点击查看直播": "点击查看直播",
  "直播主题": "直播主题",
  "时长": "时长",
  "直播状态": "直播状态",
  "直播中": "直播中",
  "结束": "结束",
  "累计观看人数": "累计观看人数",
  "累计观看人次": "累计观看人次",
  "转化预约数": "转化预约数",
  "你还没有直播过呢,快点发起直播吧~~~": "你还没有直播过呢,快点发起直播吧~~~",
  "我的直播名称": "我的直播名称",
  "直播封面": "直播封面",
  "开始直播": "开始直播",
  "直播名称": "直播名称",
  "暂无预约": "暂无预约",
  "预约时间": "预约时间",
  "成功": "成功",
  "请输入直播名称": "请输入直播名称",
  "展品列表": "展品列表",
  "对方还未登录系统，暂时不能联系": "对方还未登录系统，暂时不能联系",
  "待审核": "待审核",
  "暂无需求": "暂无需求",
  "正在直播中": "正在直播中",
  "取消会议": "取消会议",
  "采购商品名称英文": "采购商品名称英文",
  "编辑产品": "编辑产品",
  "立即查看": "立即查看",
  "公司地址": "公司地址",
  "请先输入图片验证码": "请先输入图片验证码",
  "暂无选择视频": "暂无选择视频",
  "需求图片": "需求图片",
  "提示": "提示",
  "您的设备不支持视频通话，请使用PC端谷歌浏览器打开": "您的设备不支持视频通话，请使用PC端谷歌浏览器打开",
  "登录": "登录",
  "退出": "退出",
  "展商": "展商",
  "观众": "观众",
  "更多": "更多",
  "个人中心": "个人中心",
  "同期活动": "同期活动",
  "报名人数": "报名人数",
  "时间": "时间",
  "参加报名": "参加报名",
  "推荐需求": "推荐需求",
  "推荐观众": "推荐观众",
  "暂时没有需求列表": "暂时没有需求列表",
  "暂时没有观众列表": "暂时没有观众列表",
  "广东省科技安分守己房顶上": "广东省科技安分守己房顶上",
  "下一页": "下一页",
  "上一页": "上一页",
  "未发布展品": "未发布展品",
  "发布展品": "发布展品",
  "热门推荐": "热门推荐",
  "客服热线": "客服热线",
  "通信地址": "通信地址",
  "主办单位": "主办单位",
  "热门直播": "热门直播",
  "地址": "地址",
  "取消报名": "取消报名",
  "产品封面": "产品封面",
  "已全部加载": "已全部加载",
  "点击加载": "点击加载",
  "加载中": "加载中",
  "提交成功": "提交成功",
  "需求发布成功": "需求发布成功",
  "验证码错误!": "验证码错误!",
  "验证码错误！": "验证码错误！",
  "产品视频": "产品视频",
  "热门视频": "热门视频",
  "产品编辑": "产品编辑",
  "产品新增": "产品新增",
  "场馆导航": "场馆导航",
  "专业观众": "专业观众",
  "会议直播": "会议直播",
  "启动仪式": "启动仪式",
  "预约洽谈": "预约洽谈",
  "展商直播": "展商直播",
  "视频直播": "展商直播",
  "不能和自己通话": "不能和自己通话",
  "请输入图片验证码": "请输入图片验证码",
  "不能给自己发消息": "不能给自己发消息",
  "发消息": "发消息",
  "标题": "标题",
  "直播类型": "直播类型",
  "展商展品": "展商展品",
  "展商入口": "展商入口",
  "观众入口": "观众入口",
  "前往深圳展": "前往深圳展",
  "视频直播": "展商直播",
  "展商展品": "展商展品",
  "采购需求": "采购需求",
  "热门采购需求": "热门采购需求",
  "参观指引": "参观指引",
  "平台操作指引": "平台操作指引",
  "会刊下载": "会刊下载",
  "个人中心": "个人中心",
  "热门展商": "热门展商",
  "查看更多": "查看更多",

  // 观众PC2.0展商列表
  "展商": "展商",
  "展品": "展品",
  "筛选": "筛选",
  "热度": "热度",
  "正在直播": "正在直播",
  "推荐": "推荐",

  "展会分馆": "展会分馆",
  "所有": "所有",
  "W1 雕刻馆": "W1 雕刻馆",
  "W2 耗材馆": "W2 耗材馆",
  "W3 标识馆": "W3 标识馆",
  "W4 喷印馆": "W4 喷印馆",
  "W5 喷印馆": "W5 喷印馆",
  "E1 数字标识馆": "E1 数字标识馆",

  "展位号": "展位号",

  "预约": "预约",
  "历史直播": "历史直播",
  "全部分类": "全部分类",
  //【观众PC】2.1展商详情
  "展商介绍": "展商介绍",
  "主营产品": "主营产品",

  //【观众PC】2.1展商详情
  "视频直播": "展商直播",
  "所属类别": "所属类别",

  "展品介绍": "展品介绍",
  // 【观众PC】3.0展品列表
  "请输入展品名称": "请输入展品名称",
  // 【观众PC】4.0直播列表
  "大会快看": "大会快看",
  "VR首页": "VR首页",
  "VR云上展厅": "VR云上展厅",
  "展会现场实时直播": "展会现场实时直播",
  // "全球大咖带你逛SIGN": "全球大咖带你逛SIGN",
  "会议视频": "会议视频",

  "亚洲": "亚洲",
  "欧洲": "欧洲",
  "美洲": "美洲",
  "大洋洲": "大洋洲",
  "非洲": "非洲",
  // 【观众PC】4.3主办直播详情（巡馆展开）
  "闻信": "闻信",
  "一起聊聊": "一起聊聊",
  "猜你喜欢": "猜你喜欢",
  "人观看中": "人观看中",
  // 【观众PC】5.0需求列表
  "人观看中": "人观看中",
  "采购规格": "采购规格",
  "采购数量": "采购数量",
  "采购人": "采购人",
  // 【观众PC】6.0商贸配对活动
  "活动": "活动",
  "会议房间（数量）": "会议房间（数量）",
  "洽淡时长（分钟）": "洽淡时长（分钟）",
  // 【观众PC】6.1商贸配对活动（活动详情）
  "会议入口": "会议入口",
  "返回上一页": "返回上一页",

  // 观众PC】8.0会刊下载
  "下载": "下载",

  // 【观众PC】8.0会议直播

  // 【观众PC】8.0专场采购对接会
  "专场采购对接会": "专场采购对接会",

  // 【观众PC】9.1我的需求（未添加需求）
  "未发布需求": "未发布需求",
  "点赞收藏": "点赞收藏",
  "单位名称": "单位名称",
  "职务": "职务",
  "兴趣展品": "兴趣展品",
  "商务配对活动": "商务配对活动",
  // 【观众PC】9.1.1发布需求
  "选择文件": "选择文件",
  "发布": "发布",
  "文件预览": "文件预览",
  // 【观众PC】9.2我的预约(已确认)
  "已确定": "已确定",
  "待确定": "待确定",
  // 【观众PC】9.3我的日程
  "全部日程": "全部日程",
  "备注留言": "备注留言",
  "邀约": "邀约",
  "我发起的": "我发起的",
  "展商发起的": "展商发起的",
  // 【观众PC】9.4我的消息
  "全部消息": "全部消息",
  "系统消息": "系统消息",
  "关闭": "关闭",
  // 【观众PC】9.5点赞收藏（展品）
  "展商收藏": "展商收藏",
  "展商点赞": "展商点赞",
  "展品收藏": "展品收藏",
  "展品点赞": "展品点赞",
  "收藏我的展商": "收藏我的展商",
  "点赞我的展商": "点赞我的展商",
  "收藏我的采购商": "收藏我的采购商",
  "点赞我的采购商": "点赞我的采购商",
  "观众登录": "观众登录",
  "展商登录": "展商登录",
  "获取短信验证": "获取短信验证",
  "发布展品": "发布展品",
  "我的展品": "我的展品",
  "VR展台": "VR展台",
  "展会分馆实时画面": "展会分馆实时画面",
  "分馆实时画面": "分馆实时画面",
  "全球大咖带你逛Sign China": "全球大咖带你逛Sign China",
  "全球大咖带你逛": "全球大咖带你逛Sign China",
  "展馆": "展馆",
  "展品名称": "展品名称",
  "展品名称中文": "展品名称中文",
  "选择图片": "选择图片",
  "图片上传": "图片上传",
  "视频上传": "视频上传",
  "展品类别": "展品类别",
  "上传封面": "上传封面",
  "会议开启倒计时": "会议开启倒计时",
  "商贸配对活动": "商贸配对活动",
  "商贸配对活动单位名称": "商贸配对活动单位名称",
  "人观看": "人观看",
  "暂时没有数据": "暂时没有数据",
  "拼命加载中": "拼命加载中",
  "操作成功": "操作成功",
  "操作成功!": "操作成功!",
  "暂时没有发起直播": "暂时没有发起直播",
  "直播标题": "直播标题",
  "是否公开": "是否公开",
  "公开": "公开",
  "不公开": "不公开",
  "建议尺寸": "建议尺寸",
  "格式": "格式",
  "直播视频": "直播视频",
  "发起方式": "发起方式",
  "PC端发起直播": "PC端发起直播",
  "暂停": "暂停",
  "上传直播": "上传直播",
  "没有数据": "没有数据",
  "回放": "回放",
  "展品详情": "展品详情",
  "全部": "全部",
  "专题展区名称": "专题展区名称",
  "展商分类": "展商分类",
  "展品分类": "展品分类",
  "需求列表": "需求列表",
  "采购人企业": "采购人企业",
  "热门采购商需求": "热门采购商需求",
  "品牌企业推荐": "品牌企业推荐",
  "特别鸣谢大会支持单位": "特别鸣谢大会支持单位",
  "特别鸣谢": "特别鸣谢",
  "展商直播": "展商直播",
  "展商活动": "展商活动",
  "全球大咖带你逛SIGN CHINA": "全球大咖带你逛SIGN CHINA",
  "大会直播列表": "大会视频列表",
  "展会现场实时直播列表": "展会现场实时直播列表",
  "参观指引": "参观指引",
  "职位": "职位",
  "大会直播": '大会直播',
  "大会快看": '大会快看',
  "供需大厅": '供需大厅',
  "精彩视频": "精彩视频",
  "图片直播": "图片直播",
  "分管实时画面": "分管实时画面",
  "观看": "观看",
  "展品展商": "展品展商",
  "展商名录": "展商名录",
  "参展展品": "参展展品",
  "观众收藏": "观众收藏",
  "观众点赞": "观众点赞",
  "需求收藏": "需求收藏",
  "需求点赞": "需求点赞",
  "热门需求": "热门需求",
  "已发布商机": "已发布商机",
  "已发布采购需求": "已发布采购需求",
  "采购名称": "采购名称",
  "图片": "图片",
  "全球大咖带你逛": "全球大咖带你逛",
  "实时聊天": "实时聊天",
  "展会主办单位": "展会主办单位",
  "闻信展览": "闻信展览",
  "上海办公室": "上海办公室",
  "工作办公室": "工作办公室",
  "深圳办公室": "深圳办公室",
  "没有更多": "没有更多",
  "查看视频": "查看视频",
  "采购对接会": "采购对接会",
  "视频聊天": "视频聊天",
  "直播名称": "直播名称",
  "观看": "",
  "职位": "职位",
  "关键字": "关键字",
  "图片验证码": "图片验证码",
  "短信验证码": "短信验证码",
  "密码": "密码",
  "邮箱验证码": "邮箱验证码",
  // Shanghai Edition
  "展品名称英文": "展品名称英文",
  "请输入展品名称": "请输入展品名称",
  "英文展品介绍": "英文展品介绍",
  "需求名称(英文)": "需求名称（适用于商贸对接活动，可与以上一致）",
  "需求名称(中文)": "需求名称（将发布给供应商）",
  "已暂停": "已暂停",
  "恢复": "恢复",
  "停止直播不能再恢复，确定吗？": "停止直播不能再恢复，确定吗？",
  "确定吗?": "确定吗?",
  "切换视频": "切换摄像头",
  "视频": "视频",
  "直播回放": "直播回放",
  "需求类型": "需求类型",
  "需求介绍": "需求介绍",
  "展商暂未发布展品": "展商暂未发布展品",
  "主营展品": "主营展品",
  "主营产品类型": "主营产品类型",
  "发布需求": "发布需求",
  "收藏的观众": "收藏的观众",
  "点赞的观众": "点赞的观众",
  "关注我的观众": "关注我的观众",
  "产品封面": "产品封面",
  "对方未登录": "对方未登录",
  "展商未登录": "对方未登录",
  "观众未登录": "对方未登录",
  "发起预约弹窗留言": "留言",

  "我收藏的展商": "我收藏的展商",
  "我收藏的采购商": "我收藏的采购商",
  "我收藏的展商": "我收藏的展商",
  "我点赞的采购商": "我点赞的采购商",
  "我收藏的采购需求": "我收藏的采购需求",
  "我点赞的采购需求": "我点赞的采购需求",
  "收藏的展商": "收藏的展商",
  "我点赞的展商": "我点赞的展商",
  "我收藏的展品": "我收藏的展品",
  "我点赞的展品": "我点赞的展品",
  "公司名称": "公司名称",
  "公司英文名称": "公司英文名称",
  "展品类型": "展品类型",
  "洽谈时间": "洽谈时间",
  "搜索关键词": "搜索关键词",
  "关注我的展商": "关注我的展商",
  "点赞的展商": "点赞的展商",
  "内容": "内容",
  "需求": "需求",
  "洽谈时间(分钟)": "洽谈时间(分钟)",
  "全球大咖带你逛 Sign China": "全球大咖带你逛 Sign China",
  "精选视频": "精选视频",
  "西部文化产业巡礼": "西部文化产业巡礼",
  "广州办公室": "广州办公室",
  "前往上海展": "大会官网",
  "您的设备不支持视频通话，请尝试其他浏览器": "您的设备不支持视频通话，请尝试其他浏览器",
  "是否允许打开摄像头和麦克风": "是否允许打开摄像头和麦克风",
  "观看人数": "观看人数",
  "历史回放": "历史回放",
  "停止": "停止",
  "暂停中": "暂停中",
  "已没有更多": "已没有更多",
  "未发布展品": "未发布展品",
  "展商/展品": "展商/展品",
  "深圳展": "深圳展",
  "上海展": "上海展",
  "请输入搜索关键词": "请输入搜索关键词",
  "发布时间": "发布时间",
  "公司英文介绍": "公司英文介绍",
  "主题": "主题",
  "对方未登录": "对方未登录",
  "没有需求": "没有需求",
  "未发布展品": "未发布展品",
  "请选择": "请选择",
  "请输入": "请输入",
  "选择联系人": "选择联系人",
  "查看更多": "查看更多",//查看更多
  "请输入留言": "请输入留言",
  "修改头像": "修改头像",
  "确定要退出吗": "确定要退出吗?",
  "获取验证码操作太频繁,请稍后再试": "获取验证码操作太频繁,请稍后再试",
  "还没有人找您聊天": "还没有人找您聊天",
  "了解更多": "了解更多",
  "暂无直播": "暂无直播",
  "修改密码成功": "修改密码成功",
  "原密码不能为空": "原密码不能为空",
  "新密码不能为空": "新密码不能为空",
  "确认密码不能为空": "确认密码不能为空",
  "请确认新密码与确认密码是否一致": "请确认新密码与确认密码是否一致",
  "确定要取消预约吗": "确定要取消预约吗",
  "请填写会议开始时间": "请填写会议开始时间",
  "请填写会议结束时间": "请填写会议结束时间",
  "请选择联系人": "请选择联系人",
  "选择时间": "选择时间",
  "邀约发送成功": "邀约发送成功",
  "商品品类至少选择一个": "商品品类至少选择一个",
  "图片文件不能大于1M": "图片文件不能大于1M",
  "请先上传视频封面": "请先上传视频封面",
  "您当前账号没有直播权限，请联系主办工作人员申请直播权限": "您当前账号没有直播权限，请联系主办工作人员申请直播权限",
  "上传回放成功": "上传回放成功",
  "直播名字不能为空": "直播名字不能为空",
  "请先上传视频": "请先上传视频",
  "请先上传封面": "请先上传封面",
  "预约提示发送成功": "预约提示发送成功",
  "确定要取消预约吗?": "确定要取消预约吗?",
  "请输入正确的邮箱": "请输入正确的邮箱",
  "该联系人不在线": "该联系人不在线",
  "视频文件不能大于50M": "视频文件不能大于50M",
  "未上传任何文件": "未上传任何文件",
  "上传图片像素最好不小于216*205": "上传图片像素最好不小于216*205",
  "至少需要一个图片": "至少需要一个图片",
  "媒体详情": "媒体详情",
  "我已阅读，并且同意": "我已阅读，并且同意",
  "场外展商": "场外展商",
  "名称不能为空": "名称不能为空",
  "回放直播": "回放直播",
  "上传展品图": "上传展品图",
  "邮箱格式不对": "邮箱格式不对",
  "展商推荐": "展商推荐",

  "LED大屏显示": "LED大屏显示",
  "LED照明": "LED照明",
  "数字标牌": "数字标牌",
  "专业灯光音响": "专业灯光音响",
  "其他": "其他",
  "会议视频列表": "会议视频列表",
  "大会官网": "大会官网",
  "视频邀约": "视频邀约",
  "视频邀约,点击查看": "视频邀约,点击查看",
  "点击查看": "点击查看",
  "您有一个会议正在进行中": "您有一个会议正在进行中",
  "信息不能为空": "信息不能为空",
  "Shift+Enter发消息": "Shift+Enter发消息",
  "用户名或密码错误，请重新输入！": "用户名或密码错误，请重新输入！",
  "请先上传直播封面": "请上传封面图",
  "操作失败": "操作失败",
  "请输入展商名称": "请输入展商名称",
  "请输入展品名称": "请输入展品名称",
  "观众预登记": "观众预登记",
  "综合服务": "综合服务",
  "下届展位预订": "下届展位预订",
  "需求对接": "需求对接",
  "云相册": "云相册",
  "元宇宙会议": "元宇宙会议",
  "线上展馆": "线上展馆",
  "联系我们": "联系我们",
  "中国纺织品商业协会": "中国纺织品商业协会",
  "联系电话": "联系电话",
  "预登记": "预登记",
  "劳保会": "劳保会",
  "页": "页",
  "跳转至": "跳转至",
  "没有可用的数据": "没有可用的数据",
  "选择视频": "选择视频",
  "产品名称(中文)": "产品名称(中文)",
  "产品名称(英文)": "产品名称(英文)",
  "请您先同意承诺": "请您先同意承诺",
  "展商风采": "展商风采",
  "走进现场": "走进现场",
  "展会概况": "展会概况",
  "入场登记": "入场登记",
  "大会快看": "大会快看",
  "大会快看": "大会快看",
}




// WEBPACK FOOTER //
// ./src/common/VueI18n/language-zh.js